export default __webpack_public_path__ + "static/media/suntrust.11935fec.svg";